
"use strict"; // jshint ignore:line

import { Euler } from '../../../src/js/three.module.js';
import { vec3toScreenPos } from '../GameTools.js';
import { DragHandle }      from '../services/DragHandlesService.js';

//import { PropertiesFloatGUI } from '../../features/properties-float-gui/properties-float-gui.js';

export default function HUDService( $rootScope,  gameSceneService,  entitySelectionService,  wallsHandlerService,  userActionHistoryService, gettextCatalog ) {

	var self = this;

	var canvas = this.canvas = null;
	var ctx    = this.ctx    = null;

	this.transformCtrl = null;

	this.floatGUI      = null;

	this.init = function( _canvas ) {
		this.canvas = canvas = _canvas;
		this.refreshContext();

		if (this.transformCtrl) {

			this.transformCtrl.addEventListener( "mouseDown", function( event ) {
				// console.log( "HUDService.transformCtrl.mouseDown", _dragDeltaVec.copy( self.transformCtrl.object.position ));

				event.target.dragging = true;
			});

			this.transformCtrl.addEventListener( "mouseUp", function( event ) {
				// console.log( "HUDService.transformCtrl.mouseUp", _dragDeltaVec.sub( self.transformCtrl.object.position ).multiplyScalar( -1 ));
				
				var transformCtrl = event.target;

				if (transformCtrl.dragging) {

					transformCtrl.dragging = false;

					var act = null;
					var obj = transformCtrl.object;

					if (obj && obj.userData.type == "additionalObject") {

						/**
						 * @NOTE: " || true" koska userActionHistoryService.do(Undo|Redo)("additionalObject.move") vaatii kaikki arcvot,
						 * (old|new)_(rotation|position) -m 7.9.2021
						 */

						if (!transformCtrl.worldPositionStart.equals( transformCtrl.worldPosition ) || true) {
							act = act || {};
							act.old_position = transformCtrl.worldPositionStart.clone();
							act.new_position = transformCtrl.worldPosition.clone();
						}

						if (!transformCtrl.worldQuaternionStart.equals( transformCtrl.worldQuaternion ) || true) {
							act = act || {};
							act.old_rotation = new Euler().setFromQuaternion( transformCtrl.worldQuaternionStart );
							act.new_rotation = new Euler().setFromQuaternion( transformCtrl.worldQuaternion );
						}

						if (act) {

							act.uuid = obj.uuid;

							userActionHistoryService.addUndo( "additionalObject.move", act );
						}
					}
				}
			});

			this.transformCtrl.traverse( obj => {
				// Halutaan transformCtrl:n kohteiden olevan näkymättömiä intersection-tarkastelulle
				obj.userData.intersectTransparent = true;
			});
		}

		try {
			this.floatGUI = new PropertiesFloatGUI({ container: canvas.parentNode });
		} catch (error) {
			console.error( error );
			this.floatGUI = null;
		}
	};

	this.setTransformCtrlMode = function( mode ) {
		if (self.transformCtrl) {

			self.transformCtrl.setMode( mode );

			gameService.renderNeeded = true;

			return self.transformCtrl.getMode();
		}
	}

	this.refreshContext = function() {
		this.ctx = ctx = this.canvas.getContext( "2d" );
	};

	this.onResize = function( width, height ){
		this.canvas.width  = this.width  = width;
		this.canvas.height = this.height = height;
		this.refreshContext();
	};

	this.render = (function() {
		var counter = 0;
		return function() {
			/* if (counter++ % 15 == 0) */
			renderFn();
		};
		function renderFn(){
//			console.time( "HUDService.renderFn()" );

			ctx.clearRect( 0, 0, canvas.width, canvas.height );
//			ctx.font = "30px Arial";

			try {
			    renderHelperlines();
			} catch(e) { console.error( e ); }

//			console.timeEnd( "HUDService.renderFn()" );
		}
		function renderHelperlines() {
/*					for (var i in helpers.children) {
				var line = helpers.children[i];
				if (line.isHelperLine && line.visible && line.line) {
					var ends = [];
					if ((ends[0] = vec3toScreenPos( line.line.geometry.vertices[0] )).x < -1
					  || ends[0].x > 1 || ends[0].y < -1 || ends[0].y > 1) continue;

					if ((ends[1] = vec3toScreenPos( line.line.geometry.vertices[1] )).x < -1
					  || ends[1].x > 1 || ends[1].y < -1 || ends[1].y > 1) continue;

					line.$screenEnds = ends;

				}
			}*/

			var lines = helpers.children.forEach(function( line ){
				if (!line.isHelperLine || !line.visible || !line.line) return;

				var ends = [];
				if ((ends[0] = vec3toScreenPos( line.line.geometry.vertices[0] )).x < -1 ||
				     ends[0].x > 1 || ends[0].y < -1 || ends[0].y > 1) return;

				if ((ends[2] = vec3toScreenPos( line.line.geometry.vertices[1] )).x < -1 ||
				     ends[2].x > 1 || ends[2].y < -1 || ends[2].y > 1) return;

				line.$screenEnds = ends;

				ends[1] = (-ends[0].y + 1) / 2 * canvas.height;
				ends[0] = (ends[0].x + 1)  / 2 * canvas.width;
				ends[3] = (-ends[2].y + 1) / 2 * canvas.height;
				ends[2] = (ends[2].x + 1)  / 2 * canvas.width
				ends[4] = (ends[0] + ends[2]) / 2;
				ends[5] = (ends[1] + ends[3]) / 2;

			    lineFn( ends[0], ends[1], ends[2], ends[3] );

               	// ctx.fillText( line.length.toFixed(2) + "m", ends[4], ends[5] );

				return true;
			});
		}

		function lineFn( x1, y1, x2, y2 ) {
			ctx.beginPath();
			ctx.moveTo( x1, y1 );
			ctx.lineTo( x2, y2 );
			ctx.stroke();
		}
	})();

	this.oeuvrePanelHeight = (function( elem ) {
		return function() {
			return $rootScope.__oeuvrePanelHeight || 0;
		}
	})();

	this.controlPanelWidth = (function( elem ) {
		return function() {
			return $rootScope.__controlPanelWidth || 0;
		}
	})();

	$rootScope.$on( "onSelectionChanged", (function(){
		return function( event, selection ) {

			gameService.renderNeeded = true;

			if (!gameService.editor) {
				if (self.transformCtrl) {
					self.transformCtrl.detach( );
				}

				return false;
			}

			refreshStateIndicator();

			if (self.transformCtrl) {
				var mesh;
				if (selection.length == 1) {
					mesh = solveMesh( selection[0] );
				}

				if (mesh != self.transformCtrl.object) {
					if (mesh) {
						self.transformCtrl.attach( mesh );
					} else {
						self.transformCtrl.detach( );
					}
				}
			}
		};

		function solveMesh( obj ) {
			if (obj.mesh) {
				switch (obj.mesh.userData.type) {
					case "additionalObject":
						return obj.mesh;
				}
			}
		}
	})());

	$rootScope.$on( "onAfterUserAct", function() {

		if (self.transformCtrl && self.transformCtrl.object) {
			// transformCtrl on asetettu johonkin kohteeseen

			if (!self.transformCtrl.object.parent) {
				// Kohde ei kuulu enää sceneen! -> Irrotetaan
			
				self.transformCtrl.detach( );
			}
		}
	});


	this.refreshStateIndicator = refreshStateIndicator;
	
	var lastSelected;
	function refreshStateIndicator() {
		if (wallsHandlerService.$$createNew) {
			$rootScope.stateIndicator.set( "Draw new wall to floor" );
			return;
		}

		try {
			/** @NOTE: 18.09.19 Ratkaisu useamman eri järjestelsmän yhteensopvittamiseen. Väliaikaisratkaisu -M */
			var selected = entitySelectionService.__solveSelectedEntity();

			try { 
				if (self.floatGUI) self.floatGUI.clearSetup();
			} catch (error) { console.error( error ); }

			if (selected.targets.length == 1) {
				
				console.log( "HUDService.refreshStateIndicator() :: Objekti valittu", selected );

				if (selected.type == "oeuvre" && selected.target && selected.target.title) {

					//$rootScope.stateIndicator.set( "Oeuvre '"+ selected.target.title +"' selected! Click (ESC) to unselect" );
					//$rootScope.stateIndicator.set( "Teos '"+ selected.target.title +"' valittu! Paina (ESC) poistaaksesi valinnandd" );
					$rootScope.stateIndicator.set( gettextCatalog.getString( "Oeuvre '{{ label }}' selected!", { label: selected.target.title }) +" "+ gettextCatalog.getString( "Click (ESC) to unselect" ));

				} else if (selected.type == "additionalObject") {

					//$rootScope.stateIndicator.set( "Object "+(selected.target.label||selected.target.obj_hash)+"("+selected.target.uuid+") selected! Click (ESC) to unselect" );
					$rootScope.stateIndicator.set( gettextCatalog.getString( "Object '{{ label }}' selected!", { label: (selected.target.label||selected.target.obj_hash) }) +" "+ gettextCatalog.getString( "Click (ESC) to unselect" ));

				} else if (selected.type == "additionalWall") {

					//$rootScope.stateIndicator.set( "Additional wall selected! Click (ESC) to unselect" );
					//$rootScope.stateIndicator.set( gettextCatalog.getString( "Additional wall selected! Click (ESC) to unselect" ));
					$rootScope.stateIndicator.set( gettextCatalog.getString( "Additional wall selected!" ) +" "+ gettextCatalog.getString( "Click (ESC) to unselect" ));

				} else if (selected.type == "dragHandle" && selected.target instanceof DragHandle.Polygon) {

					//$rootScope.stateIndicator.set( "DragHandle polygon selected! Click (ESC) to unselect" );
					$rootScope.stateIndicator.set( gettextCatalog.getString( "DragHandle polygon selected!" ) +" "+ gettextCatalog.getString( "Click (ESC) to unselect" ));

				} else if (selected.type == "dragHandle" && selected.target instanceof DragHandle.Comment) {

					//$rootScope.stateIndicator.set( "Comment selected! Click (ESC) to unselect" );
					$rootScope.stateIndicator.set( gettextCatalog.getString( "Comment selected!" ) +" "+ gettextCatalog.getString( "Click (ESC) to unselect" ));

				} else if (selected.type == "dragHandle") {

					//$rootScope.stateIndicator.set( "DragHandle selected! Click (ESC) to unselect" );
					$rootScope.stateIndicator.set( gettextCatalog.getString( "DragHandle selected!" ) +" "+ gettextCatalog.getString( "Click (ESC) to unselect" ));

				} else {

					$rootScope.stateIndicator.set( "Something selected!" ) +" "+ gettextCatalog.getString( "Click (ESC) to unselect" );

				}

				try { 
					if (self.floatGUI) self.floatGUI.setTarget( selected.target );
				} catch (error) { console.error( error ); }

			} else if (selected.targets.length > 1) {

				console.log( "HUDService.refreshStateIndicator() :: Useampia objekteja valittu", selected );

				if (selected.type == "oeuvre") {
					//$rootScope.stateIndicator.set( selected.targets.length + " oeuvres selected! Click (ESC) to unselect" );
					$rootScope.stateIndicator.set( gettextCatalog.getString( "{{ $count }} oeuvres selected!", { $count: selected.targets.length }) +" "+ gettextCatalog.getString( "Click (ESC) to unselect" ));
				}

			} else if (lastSelected) {
				// Ei ole valittuna *enään* mitään, mutta aiemmin oltiin -> Oletetaan stateIndicatorissa olevan viesti valitsemisisita -> Tyhjennetään stateIndicator
				$rootScope.stateIndicator.clear();
			}

			lastSelected = selected;

		} catch( err ) { console.error( err ); }
	}
}

HUDService.$inject = new Array( "$rootScope","gameSceneService","entitySelectionService","wallsHandlerService","userActionHistoryService", "gettextCatalog" );
